import { render, staticRenderFns } from "./NoMenuLayoutComponent.vue?vue&type=template&id=174e82fa&"
import script from "./NoMenuLayoutComponent.vue?vue&type=script&lang=js&"
export * from "./NoMenuLayoutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports